import React from 'react';
import styles from './autocomplete_icon.module.scss';

interface IProps<T> {
  icon: T;
}

export function AutocompleteIcon<T extends React.ReactType>({
  icon,
}: OverwritableType<IProps<T>, T>) {
  const ElementType: React.ReactType = icon;
  return <ElementType className={styles.icon} />;
}
